module.exports = [
 {
  "start": 500,
  "end": 2417,
  "text": "Another body is one of three "
 },
 {
  "start": 2500,
  "end": 4834,
  "text": "alternating large scale installations "
 },
 {
  "start": 4875,
  "end": 6542,
  "text": "that are projected "
 },
 {
  "start": 6625,
  "end": 7708,
  "text": "towards the harbour, "
 },
 {
  "start": 7834,
  "end": 11166,
  "text": "in the apartment Your Room Opposite the Opera, "
 },
 {
  "start": 11250,
  "end": 13708,
  "text": "opening up walls and the architecture. "
 },
 {
  "start": 13917,
  "end": 15500,
  "text": "The work pays tribute to the "
 },
 {
  "start": 15625,
  "end": 17417,
  "text": "unbelievable wonder that we exist "
 },
 {
  "start": 17542,
  "end": 19667,
  "text": "and consciously realise it. "
 },
 {
  "start": 19875,
  "end": 22458,
  "text": "We are a chain of happy coincidences, "
 },
 {
  "start": 22750,
  "end": 23875,
  "text": "that means every one of our ancestors"
 },
 {
  "start": 23959,
  "end": 26917,
  "text": "from unicellular organism via "
 },
 {
  "start": 27083,
  "end": 29834,
  "text": "the monkeys toward us "
 },
 {
  "start": 29917,
  "end": 32375,
  "text": "as the homo sapiens were not killed "
 },
 {
  "start": 32417,
  "end": 33959,
  "text": "before they replicated."
 },
 {
  "start": 34291,
  "end": 36583,
  "text": "The work celebrates being a human, "
 },
 {
  "start": 36708,
  "end": 39208,
  "text": "just another animal in the universe."
 }
]


// WEBPACK FOOTER //
// ./src/Rist/content/tourWorks/room8/audio6/08_6MCA Another Body.js